export default "__VITE_ASSET__BpNmjpHi__"